import Vuex from 'vuex'

import accountBalances from './accountBalances'
import integrators from './integrators'
import licenses from './licenses'
import admin from './admin'
import admins from './admins'
import clientRequests from './clientRequests'
import features from './features'
import documentStorage from './documentStorage'
import modal from './modal'
import profileFeeGroups from './profileFeeGroups'
import rates from './rates'
import countries from './countries'
import payments from './payments'
import paymentOrders from './paymentOrders'
import cardOrders from './cardOrders'
import swiftMessages from './swiftMessages'
import swiftMessageOrders from './swiftMessageOrders'
import internalLinks from './internalLinks'
import primaryFeeGroups from './primaryFeeGroups'

export default function createStore () {
  return new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    modules: {
      integrators,
      licenses,
      accountBalances,
      admin,
      admins,
      clientRequests,
      features,
      documentStorage,
      modal,
      profileFeeGroups,
      rates,
      countries,
      payments,
      paymentOrders,
      cardOrders,
      swiftMessages,
      swiftMessageOrders,
      internalLinks,
      primaryFeeGroups
    }
  })
}
